import logo from "./logo.svg";
import "./App.css";
import AllRoutes from "./AllRoutes/AllRoutes";
import Navbar from "./Navbar/Navbar";
import Footer from "./Footer/Footer";
import { useState } from "react";
import SideBar from "./Navbar/sidebar";

function App() {
  let width = window.innerWidth;

  return (
    <div className="App">
      {width <= "1000" ? <SideBar /> : <Navbar />}

      <AllRoutes />

      {width >= "400" && <Footer />}
    </div>
  );
}

export default App;
